import type { LightInvoiceFixedLineItem } from '@weft/api-definition';
import type { Currency } from '@weft/types';
import { formatNumber } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import React from 'react';
import { LightInvoiceProductSection } from './LightInvoiceProductSection';

type LightInvoiceFixedFeeChargesProps = {
  fixedLineItems: LightInvoiceFixedLineItem[]
  isPdf?: boolean;
  currency: Currency;
};

export const LightInvoiceFixedFeeCharges:React.FC<LightInvoiceFixedFeeChargesProps> = ({
  fixedLineItems,
  isPdf,
  currency,
}) => {
  return (
    <div className="space-y-5">
      {fixedLineItems.map((lineItem) => {
        return (
          <LightInvoiceProductSection
            currency={currency}
            pricing={lineItem.pricing}
            key={lineItem.productId}
            name={lineItem.modifiedName ?? lineItem.productName}
            description={lineItem.description}
            isPdf={isPdf}
            price={`${getCurrencySymbol(currency)}${formatNumber(lineItem.price)}`}
          />
        );
      })}
    </div>
  );
};